export default new Vue();
